import { Phone, Mail, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_serramenti-design/artifacts/1elffmli_finestre%20e%20colore%20logo%20sfondo%20scuro.png";

const navLinks = [
  { href: "#home", label: "Home" },
  { href: "#missione", label: "Missione" },
  { href: "#servizi", label: "Servizi" },
  { href: "#galleria", label: "Galleria" },
  { to: "/progetti", label: "Progetti" },
  { href: "#preventivo", label: "Preventivo" },
  { href: "#contatti", label: "Contatti" },
];

const services = [
  "Finestre in PVC",
  "Finestre in Alluminio",
  "Porte Finestre",
  "Infissi su Misura",
  "Persiane",
  "Installazione Professionale"
];

export default function Footer() {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#0B1E36] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="Finestre e Colore" 
              className="h-20 w-auto mb-6 rounded-lg"
            />
            <p className="text-white/70 leading-relaxed mb-6">
              Qualità, design e passione per la tua casa!
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/profile.php?id=61576471303622"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#1877F2] transition-colors"
                data-testid="footer-facebook-link"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-bold text-lg mb-6">Navigazione</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.to || link.href}>
                  {link.to ? (
                    <Link
                      to={link.to}
                      className="text-white/70 hover:text-white transition-colors"
                      data-testid={`footer-link-${link.label.toLowerCase()}`}
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      onClick={(e) => scrollToSection(e, link.href)}
                      className="text-white/70 hover:text-white transition-colors"
                      data-testid={`footer-link-${link.label.toLowerCase()}`}
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-6">I Nostri Servizi</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-white/70">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-6">Contatti</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:+393272823064"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                  data-testid="footer-phone-link"
                >
                  <Phone className="w-5 h-5" />
                  +39 327 282 3064
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@finestreecolore.it"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors"
                  data-testid="footer-email-link"
                >
                  <Mail className="w-5 h-5" />
                  info@finestreecolore.it
                </a>
              </li>
              <li className="text-white/70">
                <p className="font-medium text-white mb-1">Orari di Apertura</p>
                <p>Lunedì - Venerdì: 09:00 - 18:00</p>
                <p>Sabato e Domenica: Chiuso</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Finestre e Colore. Tutti i diritti riservati.
            </p>
            <div className="flex items-center gap-6">
              <Link 
                to="/privacy" 
                className="text-white/50 text-sm hover:text-white transition-colors"
                data-testid="footer-privacy-link"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/cookies" 
                className="text-white/50 text-sm hover:text-white transition-colors"
                data-testid="footer-cookies-link"
              >
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
